$(function(){
  setupSlider(); 
})

$.fn.slider = function() {
  var slider = $(this);  
  if (slider.length == 0) return;

  var sliderUl = $('ul', slider);
  var activeSlide = slider.attr('data-slide-to') ? slider.attr('data-slide-to') - 1 : 0;
  var slideCount = $('li', sliderUl).length;
  var movementTime = 300;
  var autoMovingTimer;
  var autoMovingEnabled = true;
  var autoMovingInterval = parseInt(slider.attr('data-sliderInterval')) || 500;

  prepareHTML();
  setupResizing();
  setupAutoMovingOnScroll();

  if(slider.hasClass('stop')) {
    stopAutoMoving();
  }

  function setupAutoMovingOnScroll() {
    var scrollTimer;
    $(window).scroll(function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(startAutoMovingVisible, 1000);
    });
    startAutoMovingVisible();    
  }

  function setupResizing() {
    var resizeTimer; 
    var resizeTimer2; 

    // On resize, run the function and reset the timeout
    $(window).resize(function() {
      clearTimeout(resizeTimer);
      clearTimeout(resizeTimer2);
      resizeTimer = setTimeout(setDimensions, 200);
      resizeTimer2 = setTimeout(setDimensions, 300);    
    });    
  }

  function startAutoMovingVisible() {
    if (slider.isInViewport(true)) { 
      resetAutoMovingTimer();
    
      $(window).off('scroll', startAutoMovingVisible);
    }
  }

  function resetAutoMovingTimer() {
     if (!autoMovingEnabled) return;

     clearTimeout(autoMovingTimer);
     autoMovingTimer = setTimeout(moveRight, autoMovingInterval);  
  }

  function stopAutoMoving() {
    autoMovingEnabled = false;
    clearTimeout(autoMovingTimer);
  }

  function prepareHTML() {
    slider.append('<span class="moveLeft arrowLeft"></span>');
    slider.append('<span class="moveRight arrowRight"></span>');
    $('.slide-hidden', slider).removeClass('slide-hidden');
    $('li:last-child', sliderUl).prependTo(sliderUl);

    var sliderDots = $('<div class="sliderDots"></div>');
    for (var i=0; i < slideCount; ++i) {
      sliderDots.append('<div class="sliderDot"></div>');
    }
    slider.after(sliderDots);
    changeActiveSliderDot(0);
    setupSliderDotsClicks();

    setDimensions();
  }

  function setupSliderDotsClicks() {
    var sliderDots = $('.sliderDot', slider.parent());
    sliderDots.click(function() {
      stopAutoMoving();
      moveTo(sliderDots.index(this));
    });
  }

  function changeActiveSliderDot() {
    $('.sliderDot', slider.parent())
      .removeClass('active')
      .eq(activeSlide).addClass('active');
  }

  function setDimensions() {
    var slideWidth = $(slider).outerWidth();
    var sliderUlWidth = slideCount * slideWidth;
    
    $('li.slide', slider).css({ width: slideWidth });
    sliderUl.css({ width: sliderUlWidth, marginLeft: - slideWidth });
    
    if (slider.attr('data-setHeight')) {
      var slides = $('ul li', slider);
      slides.height('auto');
      var maxSlideHeight = getMaxHeight(slides); 
      slider.height(maxSlideHeight)  // this way it does not count top padding into the height (unlike when setting it with css() method)
      slides.css({height: maxSlideHeight })
    }
  }

  function getMaxHeight(selection) {
    var max = 0;
    selection.each(function() {
      height = $(this).outerHeight();
      if (height > max) {
        max = height;
      }
    });

    return max;
  }

  function moveLeft() {

    if(!(slider.hasClass('stop-loop') && activeSlide == 0)) {

      $(sliderUl).animate({
        left: + $('ul li', slider).width()
      }, movementTime, function () {
        $('li:last-child', sliderUl).prependTo(sliderUl);
        $(sliderUl).css('left', '');
      });
      activeSlide = (activeSlide - 1) % slideCount;
      changeActiveSliderDot();

      resetAutoMovingTimer();
    }
  };

  function moveRight() {

    if(!(slider.hasClass('stop-loop') && activeSlide == slideCount - 1)) {

      $(sliderUl).animate({
        left: - $('ul li', slider).width()
      }, movementTime, function () {
        $('li:first-child', sliderUl).appendTo(sliderUl);
        $(sliderUl).css('left', '');
      });
      activeSlide = (activeSlide + 1) % slideCount;
      changeActiveSliderDot();
  
      resetAutoMovingTimer();

    }

    
  };

  function moveTo(index) {
    var diff = index - activeSlide;   // 4 - 2 => 2 forward

    if (diff == 0) return;
    
    for (var i = 0; i < Math.abs(diff); ++i) {
      if (diff > 0) {
        moveRight();
      }
      else {
        moveLeft();
      }
    }
  };

  $('.arrowLeft', slider).click(function () {
    stopAutoMoving();
    moveLeft();
  });

  $('.arrowRight', slider).click(function () {
    stopAutoMoving();
    moveRight();
  });
}

$.fn.isInViewport = function(partial) {

  var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;
  return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};


function setupSlider() {  
  $('.slider').each(function() {
    $(this).slider();  
  });
}
